import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { distinctUntilChanged, map, tap } from 'rxjs';

import { InternationalizationService } from '../services/internationalization.service';
import { TranslocoUtils } from '../utils/transloco.utils';

@Injectable()
export class TranslocoEffects {
  langChanges$ = createEffect(
    () =>
      this.action.pipe(
        ofType(ROUTER_NAVIGATED),
        map(() => this.i18nService.currentLocale),
        distinctUntilChanged(),
        tap((validLocale: string) => this.translocoLocaleService.setLocale(validLocale)),
        map(TranslocoUtils.mapLocaleToLang),
        tap((validLang: string) => this.translocoService.setActiveLang(validLang))
      ),
    { dispatch: false }
  );

  constructor(
    private readonly action: Actions,
    private readonly translocoService: TranslocoService,
    private readonly translocoLocaleService: TranslocoLocaleService,
    private readonly i18nService: InternationalizationService
  ) {}
}
